import { HospitalInfoEntity } from "@/domain/entity/hospital-info-entity";
import { HospitalRepository } from "@/domain/repository/hospital-repository";
import { SATError, SATResult } from "@sadtx/sat-error";

export class FetchHospitalListUsecase {
  constructor(private readonly hospitalRepo: HospitalRepository) {}

  async execute(): Promise<SATResult<HospitalInfoEntity[], SATError>> {
    return this.hospitalRepo.getHospitalList();
  }
}
